import type { Taxonomy } from "../lib/useTaxonomy.js";
import { Dialog } from "./Dialog.js";
import { LocationChooser } from "./LocationChooser.js";

/**
 * "Move 12 items to…" or "Move Shelf A into…": the location chooser over the
 * screen, a centred panel on a desktop and a sheet from the bottom on a phone.
 *
 * Tapping a place *is* the move. The title already says what will happen and
 * to how many, and the toast afterwards offers Undo, so a second Apply button
 * would be a tap on every move to guard against the rare wrong one.
 */
export function MoveDialog({
  title,
  taxonomy,
  here,
  hidden,
  unfiledLabel,
  onChoose,
  onClose,
}: {
  title: string;
  taxonomy: Taxonomy;
  here?: string | null;
  /** Not offered: a location being moved and everything below it. */
  hidden?: ReadonlySet<string>;
  /** What the "no location" row says; see LocationChooser. */
  unfiledLabel?: string;
  onChoose: (to: string | null) => void;
  onClose: () => void;
}) {
  return (
    <Dialog title={title} onClose={onClose}>
      <LocationChooser
        taxonomy={taxonomy}
        here={here}
        autoFocus
        onChoose={onChoose}
        {...(hidden ? { hidden } : {})}
        {...(unfiledLabel ? { unfiledLabel } : {})}
      />
    </Dialog>
  );
}
